import { useRef, useState } from "react";
import StockInDelete from "./stock-in-delete";
import StockInEdit from "./stock-in-edit";
import StockInList from "./stock-in-list";
import { encodeQueryParams } from "../../../utils/EncodeDecodeQueryParams";
import { useNavigate } from "react-router-dom";

const StockInMain = (props) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  const newTab = false;
  const apiUrl = "stock/stockin";

  const navigate = useNavigate();

  const [paging, setPaging] = useState({
    filter: "",
    page: 1,
    take: 10,
  });

  // handle ui event section

  // const handleOnClickRowEdit = (row) => {
  //   setEditorData(row);
  //   setVisibleEditorDialog(true);
  // };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnClickAddNew = async () => {
    const queryParamsText = `filter=${paging.filter}&page=${paging.page}&take=${paging.take}`;
    const encodedQueryParams = await encodeQueryParams(queryParamsText);

    if (newTab) {
      const url = `${process.env.REACT_APP_MY_URL}/${apiUrl}/new?key=${encodedQueryParams}`;
      window.open(url, "_blank").focus();
    } else {
      navigate(`/${apiUrl}/new?key=${encodedQueryParams}`);
    }
  };

  const handleOnClickRowEdit = async (row) => {
    const queryParamsText = `filter=${paging.filter}&page=${paging.page}&take=${paging.take}`;
    const encodedQueryParams = await encodeQueryParams(queryParamsText);

    if (newTab) {
      const url = `${process.env.REACT_APP_MY_URL}/${apiUrl}/${row.id}?key=${encodedQueryParams}`;
      window.open(url, "_blank").focus();
    } else {
      navigate(`/${apiUrl}/${row.id}?key=${encodedQueryParams}`);
    }
  };

  // const handleOnClickAddNew = () => {
  //   setEditorData({});
  //   setVisibleEditorDialog(true);
  // };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <StockInDelete
        visible={visibleDeleteDialog}
        onHide={() => setVisibleDeleteDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedDelete}
      />
      {/*
      <StockInEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      /> */}

      <StockInList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickRowDelete={handleOnClickRowDelete}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default StockInMain;
